import PropTypes from 'prop-types'
import Form from 'react-bootstrap/Form'

export const CheckboxReutilizable = ({ label, checked, onChange, name }) => {
  return (
    <>
      <Form.Check
        inline
        type="radio"
        name={name}
        checked={checked}
        onChange={() => onChange()}
        label={label}
      />
    </>
  )
}

CheckboxReutilizable.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
}
